__turbopack_context__.v({
  "cardSkeleton": "FNzkIG_cardSkeleton",
});
